const STORAGE_KEY = 'demohub_2048';
const SIZE = 4;

export function createEmptyGrid() {
  return Array.from({ length: SIZE }, () => Array(SIZE).fill(0));
}

export function addRandomTile(grid) {
  const empty = [];
  for (let r = 0; r < SIZE; r++) {
    for (let c = 0; c < SIZE; c++) {
      if (grid[r][c] === 0) empty.push({ r, c });
    }
  }
  if (empty.length === 0) return grid;
  const { r, c } = empty[Math.floor(Math.random() * empty.length)];
  const newGrid = grid.map((row) => [...row]);
  newGrid[r][c] = Math.random() < 0.9 ? 2 : 4;
  return newGrid;
}

export function initGame() {
  let grid = createEmptyGrid();
  grid = addRandomTile(grid);
  grid = addRandomTile(grid);
  return { grid, score: 0, bestScore: loadBest(), gameOver: false, won: false, history: [] };
}

function slideRow(row) {
  const filtered = row.filter((v) => v !== 0);
  const merged = [];
  let score = 0;
  let i = 0;
  while (i < filtered.length) {
    if (i + 1 < filtered.length && filtered[i] === filtered[i + 1]) {
      const val = filtered[i] * 2;
      merged.push(val);
      score += val;
      i += 2;
    } else {
      merged.push(filtered[i]);
      i++;
    }
  }
  while (merged.length < SIZE) merged.push(0);
  return { row: merged, score };
}

function rotateGrid(grid) {
  const newGrid = createEmptyGrid();
  for (let r = 0; r < SIZE; r++) {
    for (let c = 0; c < SIZE; c++) {
      newGrid[c][SIZE - 1 - r] = grid[r][c];
    }
  }
  return newGrid;
}

export function move(grid, direction) {
  let rotations = 0;
  switch (direction) {
    case 'left': rotations = 0; break;
    case 'up': rotations = 1; break;
    case 'right': rotations = 2; break;
    case 'down': rotations = 3; break;
    default: return { grid, scoreGained: 0, moved: false };
  }

  let g = grid.map((row) => [...row]);
  for (let i = 0; i < rotations; i++) g = rotateGrid(g);

  let totalScore = 0;
  let moved = false;
  const newGrid = [];

  for (let r = 0; r < SIZE; r++) {
    const { row, score } = slideRow(g[r]);
    newGrid.push(row);
    totalScore += score;
    if (row.some((v, i) => v !== g[r][i])) moved = true;
  }

  let result = newGrid;
  for (let i = 0; i < (4 - rotations) % 4; i++) result = rotateGrid(result);

  return { grid: result, scoreGained: totalScore, moved };
}

export function checkGameOver(grid) {
  for (let r = 0; r < SIZE; r++) {
    for (let c = 0; c < SIZE; c++) {
      if (grid[r][c] === 0) return false;
      if (c + 1 < SIZE && grid[r][c] === grid[r][c + 1]) return false;
      if (r + 1 < SIZE && grid[r][c] === grid[r + 1][c]) return false;
    }
  }
  return true;
}

export function checkWon(grid) {
  for (let r = 0; r < SIZE; r++) {
    for (let c = 0; c < SIZE; c++) {
      if (grid[r][c] === 2048) return true;
    }
  }
  return false;
}

export function getTileColor(value) {
  const colors = {
    0: 'transparent',
    2: '#eee4da',
    4: '#ede0c8',
    8: '#f2b179',
    16: '#f59563',
    32: '#f67c5f',
    64: '#f65e3b',
    128: '#edcf72',
    256: '#edcc61',
    512: '#edc850',
    1024: '#edc53f',
    2048: '#edc22e',
    4096: '#3c3a32',
    8192: '#3c3a32',
  };
  return colors[value] || '#3c3a32';
}

export function getTileTextColor(value) {
  return value <= 4 ? '#776e65' : '#f9f6f2';
}

export function getTileFontSize(value) {
  if (value >= 1024) return '1.4rem';
  if (value >= 128) return '1.6rem';
  return '1.8rem';
}

export function loadBest() {
  try {
    return parseInt(localStorage.getItem(STORAGE_KEY + '_best') || '0', 10);
  } catch { return 0; }
}

export function saveBest(score) {
  try {
    localStorage.setItem(STORAGE_KEY + '_best', score.toString());
  } catch { /* ignore */ }
}
